import { render } from "./SchedulerDocumentParameterForm.vue?vue&type=template&id=30a37327&scoped=true&ts=true"
import script from "./SchedulerDocumentParameterForm.vue?vue&type=script&lang=ts"
export * from "./SchedulerDocumentParameterForm.vue?vue&type=script&lang=ts"

import "./SchedulerDocumentParameterForm.vue?vue&type=style&index=0&id=30a37327&lang=scss&scoped=true"

import exportComponent from "/dati01/var/lib/jenkins/workspace/Sub_Task_Release_CE/knowage-vue/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-30a37327"]])

export default __exports__